module.exports = __webpack_public_path__ + "img/2-en.8c9d32b4.jpg";